import type { DocumentNode } from '@apollo/client';
import axios, { type AxiosInstance } from 'axios';

export interface GraphqlClientConfig {
  url: string;
  headers?: Record<string, string>;
  /** Instância axios customizada (útil para retry, interceptors) */
  axiosInstance?: AxiosInstance;
}

export interface GraphqlRequestParams {
  query: DocumentNode;
  variables?: Record<string, unknown>;
}

/**
 * Cliente GraphQL centralizado.
 * Centraliza URL, headers e permite extensão (retry, auth, etc).
 */
export const createGraphqlClient = (config: GraphqlClientConfig) => {
  const client = config.axiosInstance ?? axios;

  return async <T>({ query, variables }: GraphqlRequestParams): Promise<T> => {
    const response = await client.post<{ data: T }>(
      config.url,
      {
        query: query.loc?.source.body,
        variables,
      },
      config.headers ? { headers: config.headers } : undefined
    );

    return response.data.data;
  };
};
